<script lang="ts">
  import AddRepManually from "./AddRepManually.svelte";
  import ChatWithSupportLink from "@shared/svelte/Components/ChatWithSupportLink.svelte";
  import type { SalesRep } from "@shared/types/SalesRep";
  import type { Distributor } from "@shared/types/Distributor";
  import {
    showPreviewForbiddenFlash,
    isRestrictedRole,
  } from "@retailer/services/preview_forbidden_flash";

  export let salesRep: SalesRep;
  export let turnOffManual: any;
  export let addNewSalesRepWrapper: (salesRep: SalesRep) => void;
  export let distributor: Distributor;
  export let showDivisionDuplicateWarning: boolean;

  let emailIsValid = true;

  let addSalesRepModalWrapper = salesRep => {
    if (isRestrictedRole(["sales_rep", "supplier"])) {
      showPreviewForbiddenFlash();
      return;
    } else {
      addNewSalesRepWrapper(salesRep);
    }
  };
</script>

<div class="background-white padding--medium fizz-styles" style="width: 90vw; max-width: 600px;">
  {#if showDivisionDuplicateWarning}
    <div class="fizz-alert-error fizz-stack-16">
      <p><strong>Unable to add Sales Rep</strong></p>
      <p>
        This sales rep already exists in our system, associated with a different distributor.
        Confirm you are adding this rep to the correct distributor, if you need further assistance <ChatWithSupportLink
          message={"contact support"}
          bold={false}
        />.
      </p>
    </div>
  {/if}
  <div class="flex-row">
    <div class="grid-row">
      <div class="grid-col c12-12">
        <div class="default-body--bold">
          Enter Your Sales Rep's Information For {distributor.name}
        </div>
        <div class="default-body--regular padding-top--smallest">
          This information is used by Provi to contact your distributor rep to place orders.
          Accurate information is needed to ensure your order is received. Don't know your reps
          info? <a
            href="https://support.provi.com/s/article/what-if-i-dont-know-my-sales-rep"
            target="_blank"
            rel="noopener noreferrer"
            style="color:#007489;"
          >
            See our FAQs on identifying distributor sales reps.</a
          >
        </div>
      </div>
    </div>
  </div>
  <AddRepManually bind:salesRep bind:emailIsValid {distributor} />
</div>
<footer class="modal__footer align-right padding--smaller">
  <div class="grid-row">
    <div class="grid-col c2-12 align-left float-left">
      <button class="button button--small button--secondary" on:click={turnOffManual}>Back</button>
    </div>
    <div class="grid-col c10-12 align-right float-right">
      <button
        class="button button--small button--primary"
        disabled={!salesRep.contact_email ||
          !salesRep.name ||
          !salesRep.contact_phone ||
          !emailIsValid}
        on:click={() => addSalesRepModalWrapper(salesRep)}>Add</button
      >
    </div>
  </div>
</footer>
